import { render } from "./GestionCreditos.vue?vue&type=template&id=75a7eacb&scoped=true"
import script from "./GestionCreditos.vue?vue&type=script&lang=js"
export * from "./GestionCreditos.vue?vue&type=script&lang=js"

import "./GestionCreditos.vue?vue&type=style&index=0&id=75a7eacb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a7eacb"]])

export default __exports__